import { Chip } from '@mui/material';
import { ONBOARDING_STATUS } from '@realadvisor/constants';

import type { User_Onboarding_Status_Enum_Enum } from '@graphql/__generated__/graphql';
import { isOnboardingPendingReview } from '@modules/_shared/utils/onboardingStatus';
import { useLocale } from '@shared/hooks/locale';

type OnboardingStatusChipProps = {
  status: User_Onboarding_Status_Enum_Enum | null | undefined;
};

export const OnboardingStatusChip = ({ status }: OnboardingStatusChipProps) => {
  const { t } = useLocale();

  if (status == null) {
    return null;
  }

  let label = t('Approved');

  if (status === ONBOARDING_STATUS.inProgress) {
    label = t('In progress');
  } else if (isOnboardingPendingReview(status)) {
    label = t('Pending review');
  }

  return (
    <Chip
      label={label}
      size="small"
      color={status === ONBOARDING_STATUS.approved ? 'success' : 'warning'}
      variant="outlined"
    />
  );
};
